import { render, staticRenderFns } from "./ManagerCategoryAdd.vue?vue&type=template&id=55a8e24a"
import script from "./ManagerCategoryAdd.vue?vue&type=script&lang=js"
export * from "./ManagerCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports